import { IconMoon, IconSun } from '@tabler/icons-react'

import { Button } from '@/components/sui/button'
import { useComponentTranslation } from '@/hooks/use-component-translation'
import { useThemeStore } from '@/stores/theme'

import locales from './locales'

interface ThemeToggleProps {
  buttonClassName?: string
  iconClassName?: string
}

export function ThemeToggle({
  buttonClassName,
  iconClassName,
}: ThemeToggleProps) {
  const { t } = useComponentTranslation(locales)
  const { theme, setTheme } = useThemeStore()

  return (
    <Button
      variant="ghost"
      size="icon"
      className={buttonClassName}
      onClick={() => setTheme(theme === 'dark' ? 'light' : 'dark')}
    >
      {theme === 'dark' ? (
        <IconSun className={iconClassName ?? 'size-4'} />
      ) : (
        <IconMoon className={iconClassName ?? 'size-4'} />
      )}
      <span className="sr-only">{t('toggleTheme')}</span>
    </Button>
  )
}
